import cn from 'classnames';
import { Button } from 'src/uikit/Button';

import { Link } from '../Link';
import { ArrowLink } from './ArrowLink';
import s from './ErrorBlock.module.scss';

type ErrorCode = 404 | 500;

type ErrorDescription = {
  title: string;
  description: string;
  listLinks: {
    title: string;
    href: string;
  }[];
};

const DEFAULT_ERROR: Omit<ErrorDescription, 'title'> = {
  description: 'Но есть другие полезные страницы',
  listLinks: [
    { title: 'GitLab для начинающих', href: '/blog/gitlab-about' },
    {
      title: 'Elastic Cloud Server+',
      href: '/products/elastic-cloud-server',
    },
    {
      title: 'ML Space',
      href: '/mlspace',
    },
    {
      title: 'Evolution',
      href: '/evolution',
    },
  ],
};

const getErrorDescription = (errorCode: ErrorCode): ErrorDescription => {
  if (errorCode === 404)
    return {
      ...DEFAULT_ERROR,
      title: 'Такой страницы нет',
    };

  return {
    ...DEFAULT_ERROR,
    title: 'Неизвестная ошибка',
    description: 'Попробуйте обновить страницу',
  };
};

interface ErrorBlockProps {
  errorCode: ErrorCode;
}

export function ErrorBlock({ errorCode }: ErrorBlockProps) {
  const title = String(errorCode);

  const content: ErrorDescription = getErrorDescription(errorCode);

  return (
    <section className={s.root}>
      <h1 className={s.title}>{errorCode}</h1>
      <p className={s.subtitle}>{content.title}</p>
      <p className={s.description}>{content.description}</p>
      <ul className={s.list}>
        {content.listLinks.map((item, index) => {
          return (
            <li className={s.item} key={index}>
              <Link
                href={item.href}
                className={cn(s.link, 'link')}
                id={`error-block-link-${title}`}
                analyticsOptions={{
                  action: item.href,
                  clickZone: 'body',
                  clickElement: 'textclick',
                  clickContent: item.title,
                  uniqueId: `error-block-link-${title}`,
                  transitionType: 'inside-link',
                  clickZoneCategory: 'site-body',
                  transitionUrl: item.href,
                  transitionTypeMetrics: 'internal',
                }}
              >
                {item.title}
              </Link>
              <ArrowLink />
            </li>
          );
        })}
      </ul>
      {errorCode === 404 && (
        <Button
          link="/"
          analyticsOptions={{
            action: '/',
            clickZone: 'body',
            clickElement: 'button',
            clickContent: 'Перейти на главную',
            uniqueId: `error-block-button-lang-${title}`,
            transitionType: 'inside-link',
            clickZoneCategory: 'site-body',
            transitionUrl: '/',
            transitionTypeMetrics: 'internal',
          }}
        >
          Перейти на главную
        </Button>
      )}
      {errorCode === 500 && (
        <Button
          onClick={() => globalThis.location.reload()}
          analyticsOptions={{
            action: 'click',
            clickZone: 'body',
            clickElement: 'button',
            clickContent: 'Обновить страницу',
            uniqueId: `error-block-button-lang-${title}`,
            transitionType: 'inside-link',
            clickZoneCategory: 'site-body',
          }}
        >
          Обновить страницу
        </Button>
      )}
    </section>
  );
}
